import { MenuItem, MenuItemProps } from '@mui/material'

type MolsonMenuItemProps = MenuItemProps & {
  dataTestId?: string
}

export const MolsonMenuItem = ({
  dataTestId,
  children,
  ...props
}: MolsonMenuItemProps) => {
  return (
    <MenuItem data-testid={dataTestId} {...props}>
      {children}
    </MenuItem>
  )
}
